import { render, staticRenderFns } from "./GenericShippingMethod.vue?vue&type=template&id=47e69c16&"
import script from "./GenericShippingMethod.vue?vue&type=script&lang=js&"
export * from "./GenericShippingMethod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports